import { Box, Stack } from "@mui/material";
import React from "react";
import { Color, FontStyle, JobDisplays, Slug } from "../../constants";
import { useSelector } from "react-redux";
import { prettyDate } from "../../utils/utils";

// dt_created, job_id, title, primary_role, locations, company_name
const MyApplicationRow = ({ applicationId }) => {
  const { dt, title, logoUrl, companyName, locations, primaryRole, token } =
    useSelector((state) => state.apply.myApps.appData[applicationId]);
  return (
    <a
      href={Slug.jobResults + "/?app=" + token}
      target="_blank"
      style={{
        textDecoration: "none",
        width: "100%",
        maxWidth: "720px",
        color: "inherit",
      }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="flex-start"
        sx={{
          // px: 1,
          // py: 1,
          cursor: "pointer",

          ...FontStyle.body,
          width: "100%",
          borderRadius: JobDisplays.borderRadius,
          backgroundColor: JobDisplays.backgroundColor,
          boxShadow: JobDisplays.boxShadow,
          padding: JobDisplays.padding,
          cursor: "pointer",
          transition: "all 0.3s ease-in-out",
          position: "relative",
          "&:hover": {
            transform: "scale(1.02)",
          },
        }}>
        <img src={logoUrl} style={{ height: "48px" }} />
        <Stack direction="column" spacing={0.5}>
          <Box
            sx={{
              fontSize: { xs: "16px", sm: "18px" },
              fontWeight: "bold",
            }}>
            {title}
          </Box>
          <Box
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
            }}>
            {companyName}
          </Box>

          <Box sx={{ fontSize: "14px", color: Color.secondaryTextGray }}>
            {primaryRole} ∙ {locations.join(" ∙ ")}
          </Box>
          <Box sx={{ fontSize: "12px", color: Color.secondaryTextGray }}>
            Applied {prettyDate(dt)}
          </Box>
        </Stack>
      </Stack>
    </a>
  );
};

export default MyApplicationRow;
